/* eslint-disable camelcase */
import axios from 'axios';
import {
  MENU_FONTS_ENDPOINT,
  MENU_TEMPLATE_ENDPOINT,
  MENUSECTION_TYPES_ENDPOINT,
  MOMENT_OF_CONSUME_ENDPOINT,
  PUBLICATION_ENDPOINT,
  THEME_ENDPOINT,
  MENU_CONFIGURATION_ENDPOINT,
  MENU_PRINT_CONFIGURATION_ENDPOINT
} from './constants';

// Theme
export const themeRequest = (theme__guid) => axios.get(THEME_ENDPOINT(theme__guid));
export const editThemeRequest = (theme__guid, theme) => axios.patch(
  THEME_ENDPOINT(theme__guid),
  theme.getFormData(),
  { headers: { 'content-type': 'multipart/form-data' } }
);
// Menu Configuration
export const menuConfigurationRequest = (menuConfigurationGuid) => axios.get(MENU_CONFIGURATION_ENDPOINT(menuConfigurationGuid));
export const editMenuConfigurationRequest = (menuConfigurationGuid, menuConfiguration) => axios.patch(
  MENU_CONFIGURATION_ENDPOINT(menuConfigurationGuid),
  menuConfiguration,
  { headers: { 'content-type': 'multipart/form-data' } }
);

// Menu print configuration
export const menuPrintConfigurationRequest = (menuPrintConfigurationGuid) => axios.get(MENU_PRINT_CONFIGURATION_ENDPOINT(menuPrintConfigurationGuid));
export const editMenuPrintConfigurationRequest = (menuPrintConfigurationGuid, menuPrintConfiguration) => axios.patch(
  MENU_PRINT_CONFIGURATION_ENDPOINT(menuPrintConfigurationGuid),
  menuPrintConfiguration.serialize(),
);
// Template
export const templateListRequest = () => axios.get(MENU_TEMPLATE_ENDPOINT(), { params: { page_size: 0 } });

// Publication
export const publicationRequest = (publication__guid) => axios.patch(PUBLICATION_ENDPOINT(publication__guid));

// Moments of Consume
export const momentOfConsumeListRequest = (point_of_sale__guid) => axios.get(MOMENT_OF_CONSUME_ENDPOINT(),
  { params: { point_of_sale__guid, page_size: 0, is_managed: false } });

// Menu section types
export const menuSectionTypeListRequest = () => axios.get(MENUSECTION_TYPES_ENDPOINT());

// Menu section font
export const menuFontListRequest = () => axios.get(MENU_FONTS_ENDPOINT());
export const createMenuFontsRequest = (fontToCreate) => axios.post(MENU_FONTS_ENDPOINT(),
  fontToCreate,
  { headers: { 'content-type': 'multipart/form-data' } });

export const deleteMenuFontsRequest = (fontGuid) => axios.delete(MENU_FONTS_ENDPOINT(fontGuid));
